import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects-details-sante',
  templateUrl: './projects-details-sante.component.html',
  styleUrls: ['./projects-details-sante.component.scss']
})
export class ProjectsDetailsSanteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
